module.exports = __webpack_public_path__ + "img/calendar.b949930c.svg";